// Interim signal for "new third-party-sharing consent" clients: clients added on/after this
// date are treated as having gone through the new intake consent (Ticket 1), so they're
// auto-shareable with connected distribution partners without an advisor attestation. Clients
// added before it are "legacy" and require the attestation. Replace this date-based proxy with
// the persisted intake consent version once form services passes it back.
export const DISTRIBUTION_PARTNER_NEW_CONSENT_RELEASE_DATE = new Date('2026-07-02T00:00:00.000Z');

export function isClientUnderNewPartnerConsent(clientAddedDateTime: Date | string | null): boolean {
  if (!clientAddedDateTime) return false;

  const added =
    clientAddedDateTime instanceof Date ? clientAddedDateTime : new Date(clientAddedDateTime);

  return added.getTime() >= DISTRIBUTION_PARTNER_NEW_CONSENT_RELEASE_DATE.getTime();
}
